import auth from "api/auth";
import campaign from "api/campaign";
import card from "api/card";
import content from "api/content";
import error from "api/error";
import log from "api/log";
import partner from "api/partner";
import payment from "api/payment";
import profile from "api/profile";
import start from "api/start";
import user from "api/user";


const api = { auth, card, campaign, content, error, log, partner, payment, profile, start, user };
export default api;